

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { Select2OptionData } from 'ng-select2';
import { ToastrService } from 'ngx-toastr';
import { CreateResult } from '../models/create-result';
import { ParticipantViewModel } from '../models/participant-view-model';
import { ParticipantService } from '../services/participant.service';
import { AuthenticationService } from '../services/authentication.service';
import { UserDataStoreService } from '../services/user-data-store.service';
import { PermissionEnum } from '../services/guards/permissions';
import { MerchantService } from '../services/merchant.service';
import {ConfirmationDialogComponent} from '../partials/confirmation-dialog/confirmation-dialog.component';
import {CardAcceptorConfigService} from '../services/card-acceptor-config.service';
import {ProductProfileService} from "../services/product-profile.service";
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-product-profile-mapping-view',
  templateUrl: './product-profile-mapping-view.component.html',
  styleUrls: ['./product-profile-mapping-view.component.scss']
})
export class ProductProfileMappingViewComponent implements OnInit {

  public productProfiles: Select2OptionData[];
  public mapCustomProductProfiles: Select2OptionData[];

  public participant: ParticipantViewModel;
  public productProfilesByParticipant: any[] = [];

  public createResult: CreateResult;
  public canEdit: boolean;
  errorMessage: string;
  error: boolean;
  public selectedProductProfile: string;

  public select2options: any = {
    multiple: false,
    width: '100%',
    allowClear: true
  };

  constructor(private _modalService: NgbModal,
    private _cardAcceptorConfigService: CardAcceptorConfigService,
    private _participantService: ParticipantService,
    private _productProfileService: ProductProfileService,
    private _merchantService: MerchantService,
    private _authenticationService: AuthenticationService,
    private _toastService: ToastrService,
    private _userDataStore: UserDataStoreService,
    private _route: ActivatedRoute,
    private _ngxUiLoaderService: NgxUiLoaderService) {

  }

  public async ngOnInit(): Promise<void> {
    this._route.params.subscribe(async params => {
      this.canEdit = this._userDataStore.hasRequiredPermissions([PermissionEnum.EditParticipantConfiguration], []);
      await this.initParticipant(params.id);
      this.productProfiles = (await this._productProfileService.GetProductProfiles()).map((x) => {
        return { id: x.profileId.toString(), text: x.productProfile }
      });
      this.productProfilesByParticipant = (await this._productProfileService.GetProductProfilesForParticipant(this.participant.id)).map(p => ({
        productProfileId: p.profileId,
        participantId: this.participant.id,
      }));
      this.filterProductProfiles();
    });
  }

  public async initParticipant(id: number): Promise<void> {
    this.participant = await this._participantService.GetParticipant(id);
  }

  public filterProductProfiles(): void {
    const filteredItems = this.productProfiles.filter((item) => {
      if (this.productProfilesByParticipant != null) {
        const index = this.productProfilesByParticipant.findIndex(x => x.productProfileId.toString() === item.id);
        if (index > -1) {
          return false;
        }
      }
      return true;
    });
    this.mapCustomProductProfiles = filteredItems;
  }

  public async save(): Promise<void> {

    if (!this.canEdit) {
      this._toastService.error('You do not have the required permissions to perform this action.', 'Error');
    } else {

      this.createResult = await this._productProfileService.DeleteParticipantProductProfilesByParticipantId(this.participant.id);

      if (this.createResult.success) {
        this.createResult = await this._productProfileService.UpdateParticipantProductProfiles(this.productProfilesByParticipant);
        if (this.createResult.success) {
          this._toastService.success(this.createResult.message, 'Success');
        } else {
          this._toastService.error(this.createResult.message, 'Error');
        }
      }
      else {
        this._toastService.error(this.createResult.message, 'Error');
      }
    }
  }


  public addProductProfilesFields(): void {
    if (this.selectedProductProfile == null) {
      alert('Select a Product Profile');
    }
    else {
      this.productProfilesByParticipant.push({
        productProfileId: parseInt(this.selectedProductProfile, 10),
        participantId: this.participant.id,
      });
      this.filterProductProfiles();
    }
  }

  public deleteMappedField(productProfileId: string): void {

    const index = this.productProfilesByParticipant.findIndex(x => x.productProfileId == productProfileId);

    if (index > -1) {
      this.productProfilesByParticipant.splice(index, 1);
    }
    this.filterProductProfiles();
  }

  public async determineDeleteDialog(productProfile: string) {



    this._ngxUiLoaderService.start();
    var cardAcceptors = await this._productProfileService.GetTerminalsByProductProfile(productProfile);
    this._ngxUiLoaderService.stop();

    if (cardAcceptors <= 0) {
      await this.openDeleteConfirmationDialog(productProfile);
    }
    else {
      await this.openUsedDeleteFailureConfirmationDialog(cardAcceptors);
    }

  }

  public async openDeleteConfirmationDialog(cardset: string) {

    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.showCancel = true;
    dialogRef.componentInstance.acceptButtonText = 'Yes';
    dialogRef.componentInstance.cancelButtonText = 'No'
    dialogRef.componentInstance.title = 'Product Profile Removal'
    dialogRef.componentInstance.message = 'Are you sure you want to delete the selected product profile from participant?'

    const result = await dialogRef.result;
    if (result) {
      await this.deleteMappedField(cardset);
    }
  }

  public async openUsedDeleteFailureConfirmationDialog(count: number) {
    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.acceptButtonText = 'OK'
    dialogRef.componentInstance.title = 'Product Profile Cannot Be Removed'
    dialogRef.componentInstance.message = `The product profile is currently in use by ${count} terminal(s) and cannot be deleted.`
  }
}

